<template>
    <v-toolbar-title>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
        >
            <path
                d="M7.11756 1.16797H0.572266V7.71326H7.11756V1.16797Z"
                stroke="#647E98"
                stroke-width="0.798568"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17.4027 1.16797H10.8574V7.71326H17.4027V1.16797Z"
                stroke="#647E98"
                stroke-width="0.798568"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17.4027 11.4551H10.8574V18.0004H17.4027V11.4551Z"
                stroke="#647E98"
                stroke-width="0.798568"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.11756 11.4551H0.572266V18.0004H7.11756V11.4551Z"
                stroke="#647E98"
                stroke-width="0.798568"
                stroke-linecap="round"
                stroke-linejoin="round"
            /></svg
        ><span>{{ clientTransactionHistoryTitle }}</span>
    </v-toolbar-title>
</template>

<script>
export default {
    computed: {
        clientTransactionHistoryTitle() {
            const originalUrl = this.$route.path;
            const urlParts = originalUrl.split("/");

            const lastPart = urlParts[urlParts.length - 1];
            return lastPart
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ") || "Your IB Panel";
        },
    },
};
</script>
